module.exports = __webpack_public_path__ + "static/media/Rose Dawson.cc25b74e.png";